import React from 'react'
import LgyTooltip from '../lgy-tooltip/LgyTooltip'
import './lgy-field.scss'

const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max))

export const LgyField = ({ label, value, tooltip, children, className, inlineChildren }) => {
  const id = label || getRandomInt(100000)
  return (
    <div className={`lgy-field ${className ? className : ''}`} aria-describedby={tooltip ? `${id}-tip` : ''}>
      <span className='lgy-field-label'>{label ? label : ''}: </span>
      {children
        ? inlineChildren
          ? <span className='lgy-field-value'>{children}</span>
          : <div className='lgy-field-value'>{children}</div>
        : <span className='lgy-field-value'>{value ? value : ''}</span>}
      {tooltip && <LgyTooltip message={tooltip} id={`${id}-tip`} />}
    </div>
  )
}

export const LGYAddress = ({ className, streetNumber = '', streetAddress1, streetAddress2 = '', city, state, zip, zipSuffix = '', county = '' }) =>
  <div className={`lgy-address ${className ? className : ''}`}>
    <div className='lgy-address-line-one'>{streetNumber} {streetAddress1}</div>
    <div className='lgy-address-line-two'>{streetAddress2}</div>
    <div className='lgy-address-city-state-zip'>{city} {state} {zip}{zipSuffix && `-${zipSuffix}`}</div>
    <div className='lgy-address-county'>{county}</div>
  </div>

export default LgyField